import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/lp-logo-black.png'


const _withScopeId = n => (_pushScopeId("data-v-462b6c6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll-to" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Love on people logo"
  }),
  /*#__PURE__*/_createElementVNode("span", null, " Empowering communities by tranforming lives ")
], -1))
const _hoisted_3 = {
  href: "https://www.facebook.com/loveonpeopleofficial",
  target: "_blank"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " @loveonpeopleofficial ", -1))
const _hoisted_5 = {
  href: "https://www.instagram.com/loveonpeopleofficial/",
  target: "_blank"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " @loveonpeopleofficial ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "copyright" }, "Org nr. 802511-7006 | Copyright © 2023 - All Rights Reserved - www.loveonpeople.com", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("article", null, [
        _hoisted_2,
        _createElementVNode("div", null, [
          _createElementVNode("a", _hoisted_3, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-brands fa-square-facebook",
              color: "#3d3d3d",
              size: "xl"
            }),
            _hoisted_4
          ]),
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-brands fa-instagram",
              color: "#3d3d3d",
              size: "xl"
            }),
            _hoisted_6
          ])
        ])
      ]),
      _hoisted_7
    ])
  ]))
}